export const SCHOOL_LINK =
  'http://www.baljaffray.e-dunbarton.sch.uk/get-in-touch/';

export const EASYFUNDRAISING =
  'https://www.easyfundraising.org.uk/causes/baljaffrayprimary/';

export const LOTTERY =
  'https://www.yourschoollottery.co.uk/lottery/school/baljaffray-primary-school';

export const HALLOWEEN =
  'https://www.tickettailor.com/events/baljaffraypta/2457366';

export const PAYPAL =
  'https://www.paypal.com/donate/?hosted_button_id=D5FYPY5TALA2U';

export const XMAS_INDIVIDUAL =
  'https://www.tickettailor.com/events/baljaffraypta/1468167';

export const XMAS_FAMILY =
  'https://www.tickettailor.com/events/baljaffraypta/1468208';

export const XMAS_HAMPER =
  'https://www.tickettailor.com/events/baljaffraypta/1468228';

export const BURNS =
  'https://www.tickettailor.com/events/baljaffraypta/1527963';

export const VALENTINES =
  'https://www.tickettailor.com/events/baljaffraypta/2049857';

export const LEAVERS =
  'https://www.tickettailor.com/events/baljaffraypta/2049845';

export const MOVIE =
  'https://www.tickettailor.com/events/baljaffraypta/2099268';

export const BGT = 'https://www.tickettailor.com/events/baljaffraypta/2161411';

export const SPRING_HAMPER =
  'https://www.tickettailor.com/events/baljaffraypta/2203132';

export const SPRING_ANIMALS =
  'https://www.tickettailor.com/events/baljaffraypta/2203143';

export const SPRING_ENTRY =
  'https://www.tickettailor.com/events/baljaffraypta/2203163';

export const CHIPPY =
  'https://www.tickettailor.com/events/baljaffraypta/2393154';

export const SUMMER = 'https://canva.link/g2tvewkseumyaba';
